import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { BaseModalModule } from '../base-modal/base-modal.module';
import { SystemWarningsNotificationComponent } from './system-warnings-notification/system-warnings-notification.component';
import { SystemWarningsService } from './system-warnings.service';
import { RouterModule } from '@angular/router';
import { RefreshPageWarningModule } from '../refresh-page-warning/refresh-page-warning.module';

@NgModule({
    declarations: [SystemWarningsNotificationComponent],
    imports: [
        CommonModule,
        AngularFireDatabaseModule,
        BaseModalModule,
        RouterModule,
        RefreshPageWarningModule
    ],
    providers: [SystemWarningsService]
})
export class SystemWarningsModule {}
